const moduleOrder = [
  'dashboard'
]
export default moduleOrder



// WEBPACK FOOTER //
// ./src/modules/_order.js